import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import { informationIcon } from 'src/utils/icons';

const ShoppingCartGlCodeCell = (props: GridCellProps) => {
  const glCode = props.dataItem?.glCode?.toString()?.trim();

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" disableToolTip>
      {glCode ? (
        <div
          className="flex items-center justify-center"
          data-tooltip-id="global-tooltip"
          data-tooltip-content={glCode}
        >
          {informationIcon}
        </div>
      ) : null}
    </GridCellBase>
  );
};

export default ShoppingCartGlCodeCell;
